<template>
    <div>
        <Header/>
        <div class="step">
            <b-container>
                <b-row>
                    <b-col lg="6" class="align-self-center">
                        <b-row class="progress-mobile mb-5 mt-4">
                            <b-row>
                                <b-col cols="1">
                                    <router-link :to="{ name: 'step4'}"> <img src="../assets/img/icn_arrow_back_mobile.svg" alt="arrow icon"></router-link>
                                </b-col>
                                <b-col cols="11">
                                <ProgressBarMobile :percentage="100"/> 
                                </b-col>
                            
                            </b-row>
                        </b-row>
                        <b-row>
                            <b-col lg="12" class="mb-5">
                                <h3>ADJUNTA TUS COMPROBANTES Y ¡LISTO!</h3>
                                <p><strong>PASO 5.</strong> AGREGA TUS DOCUMENTOS</p>
                                <span>¡Este es el <strong>último paso</strong> para poder calcular tu capacidad de crédito!</span>
                            </b-col>
                            <b-form>
                                <b-row>
                                    <b-col cols="12">
                                        <b-form-group
                                            id="input-group-1"
                                            class="mb-4 relative"
                                            :class="{'active': identificacionOficial }"
                                        >
                                            <span>Identificación Oficial <span class="light">(Credencial de elector o licencia)</span></span>
                                            <b-form-file
                                            id="input-1"
                                            v-model="identificacionOficial"
                                            :class="{'required':  (btnActive && identificacionOficial=='')}"
                                            placeholder="Seleccionar un archivo"
                                            ></b-form-file>
                                            <img v-if="!identificacionOficial" class="clip-icon" src="../assets/img/icn_clip_inactive.svg" alt="id image">
                                            <img v-else class="clip-icon-delete" v-on:click="identificacionOficial=''" src="../assets/img/icn_eliminate.svg" alt="delete icon">
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12">
                                         <b-form-group
                                            id="input-group-2"
                                            class="mb-4 relative"
                                            :class="{'active': comprobanteDomicilio}"
                                        >
                                            <span>Comprobante de Domicilio <span class="light">(Recibo de luz, agua o teléfono)</span></span>
                                            <b-form-file
                                            id="input-2"
                                            v-model="comprobanteDomicilio"
                                            :class="{'required':  (btnActive && comprobanteDomicilio=='')}"
                                            placeholder="Seleccionar un archivo"
                                            ></b-form-file>
                                            <img v-if="!comprobanteDomicilio" class="clip-icon" src="../assets/img/icn_clip_inactive.svg" alt="address image">
                                            <img v-else class="clip-icon-delete" v-on:click="comprobanteDomicilio=''" src="../assets/img/icn_eliminate.svg" alt="delete icon">
                                        </b-form-group>
                                    </b-col>
                                    
                                    <b-col cols="12">
                                        <b-form-group
                                            id="input-group-3"
                                            class="mb-4 relative"
                                            :class="{'active': comprobanteIngresos}" 
                                        >
                                            <span>Comprobante de ingresos <span class="light">(Recibo de nómina o declaración de impuestos reciente)</span></span>
                                            <b-form-file
                                            id="input-3"
                                            v-model="comprobanteIngresos"
                                            :class="{'required':  (btnActive && comprobanteIngresos=='')}"
                                            placeholder="Seleccionar un archivo"
                                            ></b-form-file>
                                            <img v-if="!comprobanteIngresos" class="clip-icon" src="../assets/img/icn_clip_inactive.svg" alt="proof of income">
                                            <img v-else class="clip-icon-delete" v-on:click="comprobanteIngresos=''" src="../assets/img/icn_eliminate.svg" alt="delete icon">
                                        </b-form-group>
                                    </b-col>
                                    
                                    <b-col lg="2" class="back-desktop">
                                        <router-link class="btn-back" :to="{ name: 'step4'}"> <img src="../assets/img/icn_arrow_back.svg" alt="arrow icon"> Regresa</router-link>
                                    </b-col>
                                    <b-col lg="6">
                                        <b-button v-on:click.stop="nextStep"  class="btn-enviar mb-4">
                                            <div v-if="!loading">Conocer mi capacidad de crédito</div>
                                            <b-spinner v-else variant="light"></b-spinner>
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </b-row>
                    </b-col>
                    <b-col lg="6" class="step-progress-bar">
                        <ProgressBar  :percentage="100" :image="image" />
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import ProgressBar from '../components/ProgressStep.vue'
    import ProgressBarMobile from '../components/ProgressStepMobile.vue'
    import Header from '../components/Header.vue'
    import axios from 'axios'

    export default {
        created() {
            let urlParams = new URLSearchParams(window.location.search);
            this.emailParams = urlParams.has('applicant_email') ? urlParams.get('applicant_email') : ''
        },
        data() {
            return {
                btnActive: false,
                image: require('./../assets/img/img_paso5.png'),
                identificacionOficial: '',
                comprobanteDomicilio: '',
                comprobanteIngresos: '',
                emailParams: '',
                loading: false
            }
        },
        components: {
            ProgressBar,
            ProgressBarMobile,
            Header
        },
        methods: {
            nextStep() {
                this.loading = true
                let formData = new FormData()
                var email = this.emailParams ? this.emailParams : sessionStorage.getItem('applicant_email')
                formData.append('step', 6)
                formData.append('applicant_email', email)
                if(this.identificacionOficial)
                    formData.append('file_upload_id', this.identificacionOficial)
                if(this.comprobanteDomicilio)
                    formData.append('file_upload_address', this.comprobanteDomicilio)
                if(this.comprobanteIngresos)
                    formData.append('file_upload_money', this.comprobanteIngresos)
                console.log(formData)
                axios
                .post(
                    'https://apply.garlans.com/private/helpers/application_submit_api.php',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    },
                )
                .then((response) => {
                    this.loading = false
                    console.log(response)
                    if (!response.data.status) {      
                        let amount = response.data.response_application.credit ? response.data.response_application.credit : 0,
                            documentsUpload = Object.keys(response.data.response_documents.uploaded_img).length
                        this.$router.push({ name: 'credit', params: {amount: amount, documents: documentsUpload, applicant_country: response.data.applicant_country }})
                    } else {
                        console.log(response)
                    }
                })
                .catch((err) => {
                    console.log(err)
                    this.loading = false
                })
            }
        }
    }
</script>

<style scoped>

.step{
    padding: 3% 0;
    text-align: left;
}
h3{
    font-weight: bold;
}
p{
    font-weight: 500;
    margin-bottom: 0;
}
span{
    font-size: 13px;
}
.progress-mobile{
    display: none;
}
.light{
    color: rgba(0,0,0,0.3)
}
.txt_min{
    width: 50%;
}
label{
    margin-bottom: 10px;
}
.icon-delete{
    position: absolute;
    bottom: 34px;
    left: 0px;
}
.custom-select{
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #000;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 0;
}
.custom-select:focus{
    color: #000;
    background-color: #fff;
    border-color: #000;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
}
.form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem; 
    font-weight: 400;
    line-height: 1.5;
    color: #000;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 0;
}
.form-control::placeholder{
    color: rgba(0, 0, 0, 0.3);
}
.form-control:focus {
    color: #000;
    background-color: #fff;
    border-color: #000;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
}
.form-control:focus::placeholder{
    color: transparent;
}
.btn-enviar,
.btn-enviar:focus,
.btn-enviar:hover{
    border-radius: 0;
    color: #fff;
    background: #AF00B1;
    border: 1px solid #AF00B1;
    width: 100%;
    text-align: center;
    font-weight: bold;
}
.step-progress-bar{
    padding-left: 10%;
    padding-right: 5%;
}
.relative{
    position: relative;
}
.clip-icon{
    position: absolute;
    bottom: 10px;
    z-index: 22;
    right: 20px;
}
.clip-icon-delete{
    position: absolute;
    bottom: 12px;
    z-index: 22;
    right: 20px;
}
.required-label{
    color: #D85067;
    font-size: 10px;
    position: absolute;
    display: none;
}
.show.required-label{
    display: block;
}
@media (max-width: 1600px) {
    .clip-icon-delete{
        position: absolute;
        bottom: 15px;
        z-index: 22;
        right: 20px;
    }
}

@media (max-width: 768px) {
    .step{
        padding: 5%;
    }
    .txt_min{
        width: 100%;
    }
    .btn-next,
    .btn-next:hover,
    .btn-next:focus{
        font-size: 15px;
    }
    .back-desktop,
    .step-progress-bar{
        display: none;
    }
    .form-control,
    .custom-select {
        padding: 0.75rem;
    }
    /* .date-picker-input{
        padding-top: 0.3rem !important;
        padding-bottom: 0.3rem !important;
    } */
    .progress-mobile{
        display: block;
    }
    .form-group span{
        display:-moz-grid;
        display: -ms-grid;
        display: grid;
    }
    
    .icon-delete{
        position: absolute;
        bottom: 35px;
        left: 0px;
    }
}

</style>